(function () {
	'use strict';

	angular
		.module('uwAgenda.settings.agendasettings')
		.controller('ExternalLocationDetailController', ExternalLocationDetailController);
	
	ExternalLocationDetailController.$inject = [
		'$rootScope',
		'SharedAgendaBroadcast',
        'location',
		'allLocations',
        'Alert', 
        'ExternalLocationService',		
        '$uibModalInstance',
		'$translate'
    ];

	function ExternalLocationDetailController(
		$rootScope,
		SharedAgendaBroadcast,
        location,
		allLocations,
        Alert, 
        ExternalLocationService,		
        $uibModalInstance,
		$translate
    ) {
		var vm = this;
		
		vm.location = location;
		vm.defaultLocationDisabeled = false;

		activate();

		function activate() {
			if(!vm.location.default)
			{
				const defaultLocationExists = allLocations.find(function (location) {
					return location.default && location.id !== vm.location.id;
				});
				if(defaultLocationExists){
					vm.defaultLocationDisabeled = true;
				}
			}
		}

		vm.save = function () {
			


            if (vm.location.country) {
                vm.location.countryId = vm.location.country.id;
            } else {
                vm.location.countryId = null;
            }

			// save or update
			if (vm.location.id > 0) {
				// update
				ExternalLocationService.updateExternalLocation(vm.location)
                    .then(function() {
						Alert.success($translate.instant('external_location_updated'));

						// broadcast that the data for the current agenda owner has been updated
						$rootScope.$broadcast(SharedAgendaBroadcast.AgendaOwnerLoaded);

						$uibModalInstance.close();
					});				
			} 
			else {
				// save
				ExternalLocationService.createExternalLocation(vm.location)
				    .then(function() {
					    Alert.success($translate.instant('external_location_created'));
						
						// broadcast that the data for the current agenda owner has been updated						
						$rootScope.$broadcast(SharedAgendaBroadcast.AgendaOwnerLoaded);

					    $uibModalInstance.close();
				    });				
			}
		};

		// close modal
		vm.abort = function () {
			$uibModalInstance.dismiss();
		};	
	}
})();
